<template>
    <tr @click="recordSelected">
        <td>{{ markRecord.row_number }}</td>

        <td class="pt-1">
            {{ markRecord.name }}
        </td>

        <td>
            <v-select
                v-model="markRecord.extra_cocurricular_subject_1"
                outlined
                dense
                hide-details
                class="my-2"                
                @change="recordChanged"
                :items="extraCocurricularSubjects1"
                item-text="name"
                item-value="id"
            ></v-select>
        </td>

        <td>
            <v-text-field
                v-model="markRecord.extra_cocurricular_mark_1"
                outlined
                dense
                hide-details
                type="number"
                min=0
                max=10
                class="my-2"                
                @blur="recordChanged"
                oninput="if(Number(this.value) > this.max) this.value = this.max; else if(Number(this.value) < this.min) this.value = this.min"                
            ></v-text-field>
        </td>

        <td>
            <v-select
                v-model="markRecord.extra_cocurricular_subject_2"
                outlined
                dense
                hide-details
                class="my-2"
                @change="recordChanged"
                :items="extraCocurricularSubjects1"
                item-text="name"
                item-value="id"
            ></v-select>
        </td>

        <td>
            <v-text-field
                v-model="markRecord.extra_cocurricular_mark_2"
                outlined
                dense
                hide-details
                type="number"
                min=0
                max=10                
                class="my-2"
                @blur="recordChanged"
                oninput="if(Number(this.value) > this.max) this.value = this.max; else if(Number(this.value) < this.min) this.value = this.min" 
            ></v-text-field>
        </td>

       
        <td>
            <v-tooltip 
                bottom                
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        small
                        color="primary"                        
                        v-bind="attrs"
                        v-on="on"
                        v-show="saveState.saved"
                        class="mr-2"
                    >
                        mdi-check-all
                    </v-icon>
                </template>    
                <span>Saved</span>                
            </v-tooltip>
            <v-tooltip 
                top
                
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        small
                        color="red"                       
                        v-bind="attrs"
                        v-on="on"
                        v-show="saveState.error"
                    >
                        mdi-alert-circle
                    </v-icon>
                </template>    
                <span>Error</span>               
            </v-tooltip>
            <v-progress-circular
                indeterminate
                color="primary"
                v-if="saveState.saving"
                size="16"
                width="3"
            ></v-progress-circular>
        </td>
    </tr>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    props:{
        record: Object,
        clubs: Array,
    },    
    created() {
        this.initialize(); 
    },    
    watch: {        
        
        record: {
            deep: true,
            handler (value) {
                if(value) this.recordChanged();                    
            }
        },
        
    },       
    data() {
        return {                               
            markRecord: {},       
            saveState: {
                saved: false,
                saving: false,
                error: false
            },
            extraCocurricularSubjects1: [],
            extraCocurricularSubjects2: [],
            
        }
    },
    computed: {
        ...mapGetters({            
            getUser: 'auth/getUser',
            selectedTeacher: 'markSheet/getSelectedTeacher',   
        }),

        user () {
            return JSON.parse(this.getUser);
        }
                
    },
    methods : {
        ...mapMutations({
            setCocurricularMarkRecord: 'markSheet/setCocurricularMarkRecord',
        }),

        ...mapActions({
            postCocurricularMarkRecord: 'markSheet/postCocurricularMarkRecord',
        }),

        initialize(){ 
            //console.log(this.studentRecord);
            this.markRecord = {...this.record};
            this.extraCocurricularSubjects1 = JSON.parse(JSON.stringify(this.clubs));
            this.extraCocurricularSubjects2 = JSON.parse(JSON.stringify(this.clubs));
            this.savedDataCheck();            
        },

        async recordChanged(){

            if(this.isEmpty()){
                return;
            }
            
            this.setSaveState();

            let employeeID = this.user.employee_id;
            if(this.selectedTeacher){
                employeeID = this.selectedTeacher.id
            }

            this.setCocurricularMarkRecord({
                "student_id" : this.markRecord.student_id,
                "extra_cocurricular_subject_1" : this.markRecord.extra_cocurricular_subject_1,
                "extra_cocurricular_mark_1" : this.markRecord.extra_cocurricular_mark_1,
                "extra_cocurricular_subject_2" : this.markRecord.extra_cocurricular_subject_2,
                "extra_cocurricular_mark_2" : this.markRecord.extra_cocurricular_mark_2,
                "employee_id" : employeeID
            })

            try {
                await this.postCocurricularMarkRecord();
                this.setSaveState('saved');
                    
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
                this.$emit('error-dialog');
                this.setSaveState('error');
            }
                          
        },

        setSaveState (state = 'saving'){
            Object.keys(this.saveState).forEach(key => {
                this.saveState[key] = false;
                if(key == state) this.saveState[key] = true;
            })
        },

        isEmpty(){   
            const blank = Object.keys(this.markRecord).some(key => {
                if( 
                    (
                        key == 'extra_cocurricular_subject_1' ||
                        key == 'extra_cocurricular_mark_1' ||
                        key == 'extra_cocurricular_subject_2' ||
                        key == 'extra_cocurricular_mark_2'
                    ) &&
                    this.markRecord[key]
                )
                return true;
            })
            
            return !blank;
        },
        
        savedDataCheck(){
            if(!this.isEmpty()) this.setSaveState('saved');
        },
        recordSelected(){
            //console.log('marksheetrecord: ', this.markRecord);            
            //this.setStudentSelected(this.markRecord.name);
        },        
    }
}
</script>

<style scoped>
    .subject-comments{
        position: relative;
    }
    .subject-comments button{
        position: absolute;
        bottom: 5px;
    }

    /* Chrome, Safari, Edge, Opera */
    ::v-deep input::-webkit-outer-spin-button,
    ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    text-align:center
    }

    /* Firefox */
    ::v-deep input[type=number] {
    -moz-appearance: textfield;
    -webkit-appearance: none;
    appearance: none;
    text-align: center;
    }
</style>

